import { VSpacer } from '@nx-smartmonkey/ui';
import { Project } from '../../../../domain/project/Project';
import {
  ProjectCustomersAppType,
  ProjectCustomersFieldTypes,
  projectCustomersAppValues,
} from '../../../../domain/project/projectCustomers/ProjectCustomersFields';
import { intl } from '../../../../helpers/IntGlobalProvider';
import { useUpdateProject } from '../../../../hooks/project/useUpdateProject';
import ProjectCustomersMapper from '../../../../mappers/project/ProjectCustomersMapper';
import { Accordion } from '../../../../react-components/Accordion';
import Text from '../../../../react-components/Text';
import { CheckboxOptionPill } from './pills/CheckboxOptionPill';

const actionsFields = [`phone_call`, `customer_text_field`] as ProjectCustomersAppType[];

interface CustomersAppActionsProps {
  project: Project;
}

export const CustomersAppActions = ({ project }: CustomersAppActionsProps) => {
  const { run: editProject } = useUpdateProject({ project });

  return (
    <div
      style={{
        border: `1px solid #E0E0E0`,
        borderRadius: `2px`,
      }}
    >
      <Accordion
        id="customers_app_actions"
        expanded
        headerStyles={{
          position: `relative`,
          paddingTop: `16px`,
        }}
        headerContent={
          <Text style={{ cursor: `pointer` }} variant="body-large" isBold intlId="customers.app.options.actions" />
        }
        contentStyle={{
          padding: `16px`,
          borderTop: `1px solid #E0E0E0`,
        }}
      >
        <Text variant="label" intlId="customers.app.options.actions.info" />

        <VSpacer small />

        {actionsFields.map((option) => {
          return (
            <CheckboxOptionPill
              text={intl.formatMessage({ id: `customers.app.options.actions.${option}` })}
              selected={project.customers.fields.some((field) => field.id === option)}
              onSelect={(selected: boolean) => {
                const projectCustomers = ProjectCustomersMapper.toDTO(project.customers);

                projectCustomers.fields = selected
                  ? [
                      ...project.customers.fields,
                      { id: option, type: projectCustomersAppValues[option] as ProjectCustomersFieldTypes },
                    ]
                  : project.customers.fields.filter((field) => field.id !== option);

                editProject({
                  customers: ProjectCustomersMapper.toDomain(projectCustomers),
                });
              }}
            />
          );
        })}
      </Accordion>
    </div>
  );
};
